import { render, staticRenderFns } from "./EmbargosGoLista.vue?vue&type=template&id=422c44e8&lang=pug"
import script from "./EmbargosGoLista.vue?vue&type=script&lang=js"
export * from "./EmbargosGoLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports